import { Helmet } from 'react-helmet';

const NoAppTitle = () => (
  <Helmet titleTemplate="%s">
    <title>Egodact Admin</title>
  </Helmet>
);

export default NoAppTitle;
